import { render, staticRenderFns } from "./fccModalEtapa.vue?vue&type=template&id=323a7509"
import script from "./fccModalEtapa.vue?vue&type=script&lang=js"
export * from "./fccModalEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports